module.exports = "<header>\r\n    <h1 *ngIf=\"!isThankYouScreen\">\r\n        <div class=\"header-first-line\">{{calculatorName}}</div>\r\n        <span class=\"individual-vehicle-color\">{{categoryName}}</span>\r\n    </h1>\r\n</header>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/header/header.component.html
// module id = ./src/app/components/calculator/calculator-item/shared/header/header.component.html
// module chunks = main